"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategicOverviewCopyToBiddingResultSchema = exports.StrategicOverviewCopyToBiddingSkippedLocationSchema = void 0;
const zod_1 = require("zod");
/**
 * Schema describing a location that was skipped because no matching "Handled Contacts"
 * strategicVolume could be resolved for it during the copy operation.
 */
exports.StrategicOverviewCopyToBiddingSkippedLocationSchema = zod_1.z.object({
    workingUnitLocationId: zod_1.z.number().int(),
    reason: zod_1.z.string().min(1),
});
/**
 * Schema describing the result of copying Strategic Overview / Allocation data into
 * Bidding / Strategic. The result is a dictionary whose keys are working unit IDs and
 * whose values are per-unit statuses.
 */
exports.StrategicOverviewCopyToBiddingResultSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.object({
    success: zod_1.z.boolean(),
    writtenReports: zod_1.z.number().int().nonnegative().optional(),
    skippedLocations: exports.StrategicOverviewCopyToBiddingSkippedLocationSchema.array().optional(),
    message: zod_1.z.string().min(1).optional(),
}));
